"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PaymentsResponse {
}
exports.default = PaymentsResponse;
//# sourceMappingURL=PaymentsResponse.js.map